import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { PsaService } from '../../../create-application/psa-form/psa.service';
import { ConsultantDetails } from '../../../create-application/psa-form/psa';
import { RefDataItem, RefDataType } from '../../../shared/data-objects/ref-data-item';
import { LoginService } from '../../../shared/services/login.service';
import { RefDataService } from '../../../shared/services/ref-data.service';
import { RefDataDropdownComponent } from '../ref-data-dropdown/ref-data-dropdown.component';

const numberRE = /^[0-9]*$/;
const emailRE = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
const postcodeRE = /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/;
const streetNoRE =/^[a-zA-Z0-9- \s]+$/
const specialCharRE = /^[a-zA-Z0-9-()'#.,&\s \\ \/]+$/;

@Component({
  selector: 'app-consultant-details',
  templateUrl: './consultant-details.component.html',
  styleUrls: ['./consultant-details.component.css']
})
export class ConsultantDetailsComponent implements OnInit {

  errorMessage:any[];
  @Input() consultantDetails : ConsultantDetails;
  @Input()isReadOnly: boolean;
  applicantR:any
  
  @ViewChild('streetType')streetTypes: RefDataDropdownComponent;
  @ViewChild('unitType')unitTypes: RefDataDropdownComponent;
  @ViewChild('floorType')floorTypes: RefDataDropdownComponent;
  @ViewChild('titles')titles: RefDataDropdownComponent;

  companyNameControl:FormControl
  firstNameControl:FormControl
  lastNameControl:FormControl
 
  emailControl:FormControl
  landLineControl:FormControl
  mobileControl:FormControl
  unitNumberControl:FormControl
  floorNumberControl:FormControl
  streetNumberControl:FormControl
  streetNameControl:FormControl
  suburbControl:FormControl
  postCodeControl:FormControl

  phoneNumberControlMaxLength = 10;
  mobileNumberControlMaxLength = 10;
  postcodeControlLength=4
  phoneNumberControlMinLength = 8;
  mobileNumberControlMinLength = 10;

  constructor(private loginService: LoginService, private refDataService: RefDataService, private psaService:PsaService) { 

    this.companyNameControl=  new FormControl('',[Validators.compose([
      Validators.required,
      Validators.pattern(specialCharRE)
    ])])
    this.firstNameControl=  new FormControl('',[Validators.compose([
      Validators.required,
      Validators.pattern(specialCharRE)
    ])])
    this.lastNameControl=  new FormControl('',[Validators.compose([
      Validators.required,
      Validators.pattern(specialCharRE)
    ])])
    this.streetNameControl=  new FormControl('',[Validators.compose([
      Validators.required,
      Validators.pattern(specialCharRE)
    ])])
    this.suburbControl=  new FormControl('',[Validators.compose([
      Validators.required,
      Validators.pattern(specialCharRE)
    ])])
    
    this.emailControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.pattern(emailRE)])
    ]);
    this.landLineControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.phoneNumberControlMaxLength),
      Validators.minLength(this.phoneNumberControlMinLength),
      Validators.pattern(numberRE),
      Validators.required
    ])]);

    this.mobileControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.mobileNumberControlMaxLength),
      Validators.minLength(this.mobileNumberControlMinLength),
      Validators.pattern(numberRE),
      Validators.required
    ])]);
    this.unitNumberControl= new FormControl()
    this.floorNumberControl= new FormControl()
    this.streetNumberControl=new FormControl('', [Validators.compose([
      Validators.required,
      Validators.pattern(streetNoRE)
    ])])
   
    this.postCodeControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.postcodeControlLength),
      Validators.pattern(postcodeRE)
    ])]);

    this.psaService.onApplicantConsultantChange.subscribe(x=>{
      this.applicantR=x
    })

  }

  checkNumberInput(event)
  {
    this.psaService.applicationData.checkNumber(event)
  }

  RestrictCommaSemicolon(event)
  {
    this.psaService.applicationData.RestrictCommaSemicolon(event)
  }
  ngOnInit() {

    const pleaseSelect: RefDataItem[] = [new RefDataItem(0, 'Please Select...')];
    this.refDataService.retrieveReferenceData(RefDataType.StreetTypes, this.loginService.getToken()).subscribe(
      (refDataItems) => {
        if (this.streetTypes) {
        this.streetTypes.items = pleaseSelect.concat(refDataItems);
        this.streetTypes.selectedItemId = 0;
      }},
      err => {
        this.errorMessage = ['Server error']
      });

      this.refDataService.retrieveReferenceData(RefDataType.UnitTypes, this.loginService.getToken()).subscribe(
        (refDataItems) => {
          if (this.unitTypes) {
          this.unitTypes.items = pleaseSelect.concat(refDataItems);
          this.unitTypes.selectedItemId = 0;
        }},
        err => {
          this.errorMessage = ['Server error']
        });

        this.refDataService.retrieveReferenceData(RefDataType.FloorTypes, this.loginService.getToken()).subscribe(
          (refDataItems) => {
            if (this.floorTypes) {
            this.floorTypes.items = pleaseSelect.concat(refDataItems);
            this.floorTypes.selectedItemId = 0;
          }},
          err => {
            this.errorMessage = ['Server error']
          });

          this.refDataService.retrieveReferenceData(RefDataType.Titles, this.loginService.getToken()).subscribe(
            (refDataItems) => {
              if (this.titles) {
              this.titles.items = pleaseSelect.concat(refDataItems);
              this.titles.selectedItemId = 0;
            }},
            err => {
              this.errorMessage = ['Server error']
            });



  }
  public handleStreetTypeChanged($event) {
    const selectedItem: RefDataItem = this.streetTypes.selectedItem;
    if (selectedItem) {
      this.consultantDetails.structuredPostal.streetType = selectedItem.display;
      if (typeof selectedItem.id === 'number' || typeof selectedItem.id === 'string') {
        this.consultantDetails.structuredPostal.streetTypeId = <number>(selectedItem.id);
      }

    }
  }
  public handleUnitTypeChanged($event) {
    const selectedItem: RefDataItem = this.unitTypes.selectedItem;
    if (selectedItem) {
      this.consultantDetails.structuredPostal.unitType = selectedItem.display;
      if (typeof selectedItem.id === 'number' || typeof selectedItem.id === 'string') {
        this.consultantDetails.structuredPostal.unitTypeId = <number>(selectedItem.id);
      }

    }
  }

  handleTitleChanged($event) {
    const selectedItem: RefDataItem = this.titles.selectedItem;
    if (selectedItem) {
      this.consultantDetails.title = selectedItem.display;
    }
  }
  public handleFloorTypeChanged($event) {
    const selectedItem: RefDataItem = this.floorTypes.selectedItem;
    if (selectedItem) {
      this.consultantDetails.structuredPostal.floorType = selectedItem.display;
      if (typeof selectedItem.id === 'number' || typeof selectedItem.id === 'string') {
        this.consultantDetails.structuredPostal.floorTypeId = <number>(selectedItem.id);
      }

    }
  }
  get invalid(): boolean {
    return (
      this.companyNameControl.invalid ||
      this.firstNameControl.invalid ||
      this.lastNameControl.invalid ||
     
      this.emailControl.invalid ||
      this.landLineControl.invalid ||
      this.mobileControl.invalid ||
      this.streetNumberControl.invalid ||
      this.streetNameControl.invalid ||
      this.suburbControl.invalid ||
      this.postCodeControl.invalid ||
      (!this.consultantDetails.structuredPostal.streetType || this.streetTypes.selectedItem.display === "Please Select...")
     // ||(!this.consultantDetails.title||
       // this.titles.selectedItem.display === "Please Select...")
    );
  }

  displayErrorMessage(): string[] {
    this.companyNameControl.markAsTouched();
    this.lastNameControl.markAsTouched();
    this.firstNameControl.markAsTouched();
   
    this.lastNameControl.markAsTouched();
    this.emailControl.markAsTouched();
    this.landLineControl.markAsTouched();
    this.mobileControl.markAsTouched();
    this.streetNumberControl.markAsTouched();
    this.streetNameControl.markAsTouched();
    this.suburbControl.markAsTouched();
    this.postCodeControl.markAsTouched();

    this.errorMessage = [];

    let errorText = "";

    if (
      this.companyNameControl.invalid ||
      this.firstNameControl.invalid ||
      this.lastNameControl.invalid ||
     
      this.emailControl.invalid ||
      this.landLineControl.invalid ||
      this.mobileControl.invalid ||
      this.streetNumberControl.invalid ||
      this.streetNameControl.invalid ||
      this.suburbControl.invalid ||
      this.postCodeControl.invalid 
      //||(!this.consultantDetails.title||
       // this.titles.selectedItem.display === "Please Select...")
    ) {
      if (
        this.companyNameControl.hasError("required") ||
        this.firstNameControl.hasError("required") ||
        this.lastNameControl.hasError("required") ||
       
        this.emailControl.hasError("required") ||
        this.landLineControl.hasError("required") ||
        this.mobileControl.hasError("required") ||
        this.streetNumberControl.hasError("required") ||
        this.streetNameControl.hasError("required") ||
        this.suburbControl.hasError("required") ||
        this.postCodeControl.hasError("required")
       //  ||(!this.consultantDetails.title||
        //  this.titles.selectedItem.display === "Please Select...")
      ) {
        this.errorMessage.push("Please fill the mandatory fields");
      }
      if(this.emailControl.hasError('pattern'))
      {
        this.errorMessage.push('Please enter a valid Email')
      }
      if(this.landLineControl.hasError('pattern'))
      {
        this.errorMessage.push('Please enter a valid Phone')
      }

      if(this.landLineControl.hasError('minlength'))
      {
       
        this.errorMessage.push(`Phone Number must be at least ${this.phoneNumberControlMinLength} characters`)
      }

      if(this.landLineControl.hasError('maxlength'))
      {
        this.errorMessage.push(`Phone number cannot exceed ${this.phoneNumberControlMaxLength} characters`)
      }

      if(this.mobileControl.hasError('pattern'))
      {
        this.errorMessage.push('Please enter a valid Mobile')
      }

      if(this.mobileControl.hasError('minlength'))
      {
        this.errorMessage.push(`Mobile Number must be at least ${this.mobileNumberControlMinLength} characters`)
      }

      if(this.mobileControl.hasError('maxlength'))
      {
        this.errorMessage.push(`Mobile number cannot exceed ${this.mobileNumberControlMaxLength} characters`)
      }

      if(this.postCodeControl.hasError('pattern')){
        this.errorMessage.push ('Please enter valid four digit postcode, e.g. 3000')
      }
      if(this.streetNumberControl.hasError('pattern'))
      {
        this.errorMessage=["Only numbers, alphabets, space , hyphen (-) are allowed to enter in street number"]
      }

      if(this.postCodeControl.hasError('maxlength'))
      {
        this.errorMessage.push(`Postcode  cannot exceed ${this.postcodeControlLength} characters`)
      }

      if(this.streetNameControl.hasError('pattern') || 
      this.suburbControl.hasError('pattern') || 
      this.firstNameControl.hasError('pattern') || 
      this.lastNameControl.hasError('pattern') ||
      this.companyNameControl.hasError('pattern')
      )
      {
        this.errorMessage=["Text can contain following characters only - \ / () ' # . , & "]
      }
    

    }
    if(!this.consultantDetails.structuredPostal.streetType || this.streetTypes.selectedItem.display === "Please Select..." )
    {
      this.errorMessage.push ('Please enter Street Type')
    }

    this.markValidationControlsAsUntouched();

    return this.errorMessage;
  }

  markValidationControlsAsUntouched() {
    this.companyNameControl.markAsUntouched();
    this.lastNameControl.markAsUntouched();
    this.firstNameControl.markAsUntouched();
    this.lastNameControl.markAsUntouched();
    this.emailControl.markAsUntouched();
    this.landLineControl.markAsUntouched();
    this.mobileControl.markAsUntouched();
    this.streetNumberControl.markAsUntouched();
    this.streetNameControl.markAsUntouched();
    this.suburbControl.markAsUntouched();
    this.postCodeControl.markAsUntouched();
  }

  copy () {
    
    if(this.psaService.applicationData.applicant)
    {
        this.consultantDetails.accountName= this.psaService.applicationData.applicant.accountName
        this.consultantDetails.title= this.psaService.applicationData.applicant.title
        this.consultantDetails.firstName=this.psaService.applicationData.applicant.firstName
        this.consultantDetails.lastName=this.psaService.applicationData.applicant.lastName
        this.consultantDetails.email=this.psaService.applicationData.applicant.email
        this.consultantDetails.landLine=this.psaService.applicationData.applicant.landLine
        this.consultantDetails.mobile=this.psaService.applicationData.applicant.mobile
        this.consultantDetails.structuredPostal.street=this.psaService.applicationData.applicant.structuredPostal.street
        this.consultantDetails.structuredPostal.streetNumber=this.psaService.applicationData.applicant.structuredPostal.streetNumber
        this.consultantDetails.structuredPostal.postCode=this.psaService.applicationData.applicant.structuredPostal.postCode
        this.consultantDetails.structuredPostal.suburb=this.psaService.applicationData.applicant.structuredPostal.suburb
        this.consultantDetails.structuredPostal.unitNumber=this.psaService.applicationData.applicant.structuredPostal.unitNumber

        this.consultantDetails.structuredPostal.streetType=this.psaService.applicationData.applicant.structuredPostal.streetType
        this.consultantDetails.structuredPostal.unitType=this.psaService.applicationData.applicant.structuredPostal.unitType
        this.consultantDetails.structuredPostal.floorNumber=this.psaService.applicationData.applicant.structuredPostal.floorNumber
        this.consultantDetails.structuredPostal.floorType=this.psaService.applicationData.applicant.structuredPostal.floorType
        this.consultantDetails.structuredPostal.unitTypeId= this.psaService.applicationData.applicant.structuredPostal.unitTypeId
        this.consultantDetails.structuredPostal.floorTypeId= this.psaService.applicationData.applicant.structuredPostal.floorTypeId


        let street=  this.streetTypes.items.find(s=>s.display === this.psaService.applicationData.applicant.structuredPostal.streetType)
        this.streetTypes.selectedItemId = street.id
        this.consultantDetails.structuredPostal.streetTypeId=<number>(street.id)
        
        let unit=  this.unitTypes.items.find(s=>s.display === this.psaService.applicationData.applicant.structuredPostal.unitType)
        if(unit){
        this.unitTypes.selectedItemId = unit.id
        }
        let floor=  this.floorTypes.items.find(s=>s.display === this.psaService.applicationData.applicant.structuredPostal.floorType)
        if(floor)
        this.floorTypes.selectedItemId = floor.id

        let title=  this.titles.items.find(s=>s.display === this.psaService.applicationData.applicant.title)
        if(title)
        this.titles.selectedItemId = title.id
    }


   }

   clearControls(){
 
    this.companyNameControl.reset()
    this.lastNameControl.reset();
    this.firstNameControl.reset();
    this.lastNameControl.reset();
    this.emailControl.reset();
    this.landLineControl.reset();
    this.mobileControl.reset();
    this.streetNumberControl.reset();
    this.streetNameControl.reset();
    this.suburbControl.reset();
    this.postCodeControl.reset();
    this.unitNumberControl.reset()
    this.floorNumberControl.reset()
    this.streetTypes.selectedItemId = 0
    this.unitTypes.selectedItemId = 0
    this.floorTypes.selectedItemId = 0
    this.titles.selectedItemId=0
  }

  set applicant(v){
    this.psaService.onApplicantConsultantChange.next(v)
    if(v)
    {
      this.copy()
      
    }
    else{

      this.clearControls()
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/consultant-details/consultant-details.component.ts